export var SearchContentMutationTypes;
(function (SearchContentMutationTypes) {
    SearchContentMutationTypes["INIT_STATE"] = "INIT_STATE";
    SearchContentMutationTypes["SET_SORT_TYPE"] = "SET_SORT_TYPE";
    SearchContentMutationTypes["SET_SEARCH_FORM"] = "SET_SEARCH_FORM";
    SearchContentMutationTypes["RESET_LIST"] = "RESET_LIST";
    SearchContentMutationTypes["SEARCH_CONTENTS"] = "SEARCH_CONTENTS";
})(SearchContentMutationTypes || (SearchContentMutationTypes = {}));
